import React from 'react';

export default function CircleCheck({ height, width, stroke }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 17" fill="none">
      <path d="M14.5339 7.16666C14.8384 8.66086 14.6214 10.2143 13.9192 11.5679C13.2169 12.9214 12.0719 13.9934 10.675 14.6049C9.27803 15.2164 7.7137 15.3305 6.24281 14.9282C4.77193 14.526 3.48341 13.6316 2.59213 12.3943C1.70085 11.157 1.26069 9.65148 1.34505 8.12892C1.42941 6.60635 2.0332 5.15872 3.05571 4.02744C4.07823 2.89616 5.45767 2.14961 6.96399 1.9123C8.47031 1.67498 10.0125 1.96123 11.3333 2.72333" stroke="#00BC7D" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6 7.83366L8 9.83366L14.6667 3.16699" stroke={stroke} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
